"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseQuestion = _interopRequireDefault(require("./BaseQuestion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class ChoicesQuestion extends _BaseQuestion.default {
  updateMetaData() {
    const choices = this.question.choices.filter(c => this.selections.includes(c.text));
    const topLevelEnable = this.question.enable;
    this.handleFlags(topLevelEnable);
    choices.forEach(choice => {
      const {
        characteristics,
        enable,
        recommendationCategories
      } = choice;
      this.handleFlags(enable);
      super.handleCharacteristics(characteristics);
      this.handleRecommendationCategories(recommendationCategories);
    });
    return this.metadata;
  }
}
exports.default = ChoicesQuestion;